<template>
  <div v-loading="loading" class="product-add">
    <el-tabs v-model="activeName" type="card" @change="onActiveChange">
      <el-tab-pane label="基础设置" name="basic"></el-tab-pane>
      <el-tab-pane label="价格政策" name="priceStage"></el-tab-pane>
      <el-tab-pane label="设备详情" name="content"></el-tab-pane>
      <el-tab-pane label="高级设置" name="buyset"></el-tab-pane>
      <el-tab-pane label="设备状态" name="status"></el-tab-pane>
      <el-tab-pane label="功能设置" name="functionInvoke" :lazy="true"></el-tab-pane>
      <el-tab-pane label="设备海报" name="poster" :lazy="true"></el-tab-pane>
      <el-tab-pane label="会员列表" name="user"></el-tab-pane>
    </el-tabs>
    <!--form表单-->
    <el-form v-if="!loading" ref="form" :model="form" label-width="180px" size="small">
      <!--基础信息-->
      <Basic v-show="activeName == 'basic'" :scene="scene"></Basic>
      <!--价格政策-->
      <PriceStage v-show="activeName == 'priceStage'" :scene="scene"></PriceStage>
      <!--设备详情-->
      <Content v-show="activeName == 'content'"></Content>
      <!--高级设置-->
      <Buyset v-show="activeName == 'buyset'"></Buyset>
      <User v-show="activeName == 'user'"></User>
      <!--提交-->
      <div class="common-button-wrapper"
           v-show="activeName !== 'functionInvoke' && activeName !== 'poster' && activeName !== 'whiteList' && activeName !== 'blackList'">
        <el-button size="small" type="info" @click="cancelFunc">取消</el-button>
        <el-button :disabled="save_loading" size="small" type="primary" @click="onSubmit">发布</el-button>
      </div>
    </el-form>

    <!--设备状态-->
    <Status v-if="activeName == 'status'"></Status>
    <!--功能设置-->
    <FunctionInvoke v-if="activeName == 'functionInvoke' && form.model.version==10"></FunctionInvoke>
    <FunctionInvokeV2 v-if="activeName == 'functionInvoke' && form.model.version==20"></FunctionInvokeV2>
    <!--设备海报-->
    <Poster v-if="activeName == 'poster'"></Poster>
    <!--白名单-->
    <WhiteList v-if="activeName == 'whiteList'" :productId="id"></WhiteList>
    <!--黑名单-->
    <BlackList v-if="activeName == 'blackList'" :productId="id"></BlackList>
  </div>
</template>

<script>
import PorductApi from '@/api/product.js';
import Basic from './part/Basic.vue';
import PriceStage from './part/PriceStage.vue';
import FunctionInvoke from './part/FunctionInvoke.vue';
import FunctionInvokeV2 from './part/FunctionInvokeV2.vue';
import Content from './part/Content.vue';
import Buyset from './part/Buyset.vue';
import Poster from './part/Poster.vue';
import Status from './part/Status.vue';
import User from './user/index.vue';
import WhiteList from './part/WhiteList.vue';
import BlackList from './part/BlackList.vue';
import {formatModel} from '@/utils/base.js';

export default {
  components: {
    /*基础信息*/
    Basic,
    /*价格政策*/
    PriceStage,
    /*设备详情*/
    Content,
    /*设备状态*/
    Status,
    /*功能设置*/
    FunctionInvoke,
    FunctionInvokeV2,
    /*高级设置*/
    Buyset,
    /*设备海报*/
    Poster,
    /*白名单*/
    WhiteList,
    /*黑名单*/
    BlackList,
    User,
  },
  data() {
    return {
      activeName: 'basic',
      /*设备ID*/
      id: 0,
      /*判断是编辑*/
      scene: 'edit',
      /*是否正在加载*/
      loading: true,
      /*是否正在提交保存*/
      save_loading: false,
      /*form表单数据*/
      form: {
        model: {},
        /*设备分类*/
        catgory: [],
        /*运费模板*/
        delivery: [],
        /*会员等级*/
        gradeList: [],
        /*规格数据*/
        specData: null,
        /*是否锁住*/
        isSpecLocked: false,
        /*万能表单*/
        tableList: [],
        /*分销基础设置*/
        basicSetting: {},
        /*分销佣金设置*/
        agentSetting: {},
        audit_setting: {}
      },
      /*模型数据*/
      model: {
        /*设备名称*/
        name: '',
        productNo: '',
        videoId: 0,
        videoFilePath: '',
        posterId: 0,
        posterFilePath: '',
        verifyCode: '',
        number: '',
        /*设备分类*/
        categoryId: 0,
        printLimits: 0,
        printPrice: 0,
        printTitle: '',
        printPhone: '',
        unit: 0,
        hideLength: 0,
        maxTareWeight: 0,
        effectiveDuration: 0,
        twiceDays: 0,
        twiceType: 0,
        isOverloadPay: 1,
        isAutoPrint: 1,
        isMultiple: 0,
        weightLimit: 0,
        printItems: [],
        weightTypes: [],
        storeId: 0,
        /*设备图片*/
        image: [],
        isPicture: 0,
        contentImage: [],
        /*设备卖点*/
        sellingPoint: '',
        /*规格类别,默认10单规格，20多规格*/
        specType: 10,
        /*库存计算方式,默认20付款减库存，10下单减库存*/
        deductStockType: 20,
        storeVo: {},
        /*单规格*/
        sku: {
          /*规格类别,默认10单规格，20多规格*/
          stageType: 10,
          productSkuId: 0,
          /*产品价格*/
          productPrice: 0,
          /*产品划线价*/
          linePrice: 0,
          /*库存数量*/
          stockNum: 0,
          /*设备重量*/
          productWeight: 0,
          /*设备编码*/
          productNo: '',
          /*价格政策类别*/
          stageMany: {
            /*价格政策类别*/
            stageAttr: [],
          },
        },
        /*多规格类别*/
        specMany: {
          /*多规格类别*/
          specAttr: [],
          /*多规格表格数据*/
          specList: []
        },
        /*设备详情内容*/
        content: '',
        /*运费模板ID*/
        deliveryId: '',
        /*设备状态*/
        productStatus: 10,
        /*初始销量*/
        salesInitial: 0,
        /*设备排序，默认100*/
        productSort: 100,
        /*是否开启积分赠送,默认1为开启，0为关闭*/
        isPointsGift: 1,
        /*是否允许使用积分抵扣,默认1为允许，0为不允许*/
        isPointsDiscount: 1,
        /*最大积分抵扣数量*/
        maxPointsDiscount: 0,
        /*限购会员*/
        gradeIds: [],
        /*是否虚拟设备*/
        isVirtual: 1,
        /*限购数量*/
        limitNum: 0,
        /*虚拟设备发货方式*/
        virtualAuto: 1,
        /*虚拟设备发货内容*/
        virtualContent: ''
      }
    };
  },
  provide: function () {
    return {
      form: this.form
    };
  },
  created() {
    /*获取列表*/
    this.id = this.$route.query.productId;
    this.scene = this.$route.query.scene;
    this.getData();
  },
  methods: {
    /**
     * 获取基础数据
     */
    getData: function () {
      let self = this;
      PorductApi.getEditData(
        {
          id: self.id,
          scene: self.scene
        },
        true
      )
        .then(res => {
          self.loading = false;
          Object.assign(self.form, res.data);
          if (res.data.specData) {
            self.$set(self.form.model, 'specMany', res.data.specData);
          } else {
            self.$set(self.form.model, 'specMany', {
              specAttr: [],
              specList: []
            });
            // self.form.model.sku = res.data.model.sku[0];
          }

          if (res.data.model.printItems) {
            self.$set(self.form.model, 'printItems', res.data.model.printItems);
          } else {
            self.$set(self.form.model, 'printItems', []);
          }

          if (res.data.model.weightTypes) {
            self.$set(self.form.model, 'weightTypes', res.data.model.weightTypes);
          } else {
            self.$set(self.form.model, 'weightTypes', []);
          }

          // 等级id转换成数组
          if (self.form.model.gradeIds != '') {
            self.form.model.gradeIds = self.form.model.gradeIds.split(',');
            for (let i = 0; i < self.form.model.gradeIds.length; i++) {
              self.form.model.gradeIds[i] = parseInt(self.form.model.gradeIds[i]);
            }
          }

          if (self.form.model.storeVo != null) {
            self.$set(self.form.model, 'storeId', self.form.model.storeVo.storeId);
          }
        })
        .catch(error => {
          self.loading = false;
        });
    },

    /*转JSON字符串*/
    convertJson(list) {
      let obj = {};
      list.forEach(item => {
        obj[item.grade_id] = item.product_equity;
      });
      return JSON.stringify(obj);
    },

    /*提交*/
    onSubmit: function () {
      let self = this;
      self.$refs.form.validate(valid => {
        if (valid) {
          let params = formatModel(self.model, self.form.model);
          params.scene = self.scene;
          params.id = self.id;
          if (params.gradeIds.length > 0) {
            params.gradeIds = params.gradeIds.join(',');
          } else {
            params.gradeIds = '';
          }

          if (params.specType === 10) {
            params.sku = self.form.model.sku[0]
          }
          self.save_loading = true;
          PorductApi.editProduct(params, true)
            .then(data => {
              self.save_loading = false;
              self.$message({
                message: '保存成功',
                type: 'success'
              });
              self.cancelFunc();
            })
            .catch(error => {
              self.save_loading = false;
            });
        }
      });
    },

    /*保存为草稿*/
    Draft() {
      let self = this;
      self.form.model.productStatus = 30;
      self.onSubmit();
    },

    /*取消*/
    cancelFunc() {
      this.$router.back(-1);
    },
    onActiveChange(value) {
      let self = this;
      if (self.activeName === 'functionInvoke') {
        // 功能设置标签页逻辑
      } else if (self.activeName === 'whiteList' || self.activeName === 'blackList') {
        // 白名单或黑名单标签页逻辑
      } else {
        // 其他标签页逻辑
      }
    },
  }
};
</script>

<style lang="scss" scoped>
.basic-setting-content {
}

.product-add {
  padding-bottom: 50px;
}
</style>



// WEBPACK FOOTER //
// src/views/product/product/edit.vue